import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useI18n } from "@/contexts/I18nContext";
import { PlayCircle } from "lucide-react";

// Vimeo IDs + privacy hash extracted from the links the app owner supplied.
// player.vimeo.com (not vimeo.com/ID) is the embeddable player URL; the
// `h` query param is Vimeo's per-video privacy hash for unlisted videos —
// same pattern already used for the Landing page's hero video.
const VIDEOS = [
  {
    id: "1217665191",
    hash: null,
    titleKey: "how_to_use.video1_title",
    descKey: "how_to_use.video1_desc",
  },
  {
    id: "1217665190",
    hash: "4d7d1dca27",
    titleKey: "how_to_use.video2_title",
    descKey: "how_to_use.video2_desc",
  },
  {
    id: "1217665189",
    hash: "d574507346",
    titleKey: "how_to_use.video3_title",
    descKey: "how_to_use.video3_desc",
  },
];

function vimeoSrc(id, hash) {
  const base = `https://player.vimeo.com/video/${id}`;
  const params = new URLSearchParams({ controls: "1", title: "0", byline: "0", portrait: "0" });
  if (hash) params.set("h", hash);
  return `${base}?${params.toString()}`;
}

export default function HowToUse() {
  const { t } = useI18n();

  return (
    <div className="min-h-screen flex flex-col" data-testid="how-to-use-page">
      <Header />
      <main className="flex-1 max-w-[896px] mx-auto w-full px-5 sm:px-8 py-12">
        <div className="text-xs uppercase tracking-[0.22em] text-[#D97706] font-semibold">{t("how_to_use.eyebrow")}</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold mt-2 text-[#1F2937]">{t("how_to_use.title")}</h1>
        <p className="text-[#4B5563] mt-3 max-w-2xl">{t("how_to_use.intro")}</p>

        <div className="mt-10 flex flex-col gap-10">
          {VIDEOS.map((v, i) => (
            <div key={v.id} data-testid={`how-to-use-video-${i + 1}`} className="rounded-2xl bg-white border border-[#E7E0D2] p-5 sm:p-6">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-[#ECFDF5] border border-[#A7F3D0] grid place-items-center shrink-0 mt-0.5">
                  <PlayCircle className="w-4 h-4 text-[#064E3B]" />
                </div>
                <div>
                  <h2 className="font-heading text-lg font-semibold text-[#1F2937]">{t(v.titleKey)}</h2>
                  <p className="text-sm text-[#4B5563] mt-1">{t(v.descKey)}</p>
                </div>
              </div>
              <div className="relative w-full aspect-video rounded-xl overflow-hidden mt-4">
                <iframe
                  className="w-full h-full"
                  src={vimeoSrc(v.id, v.hash)}
                  title={t(v.titleKey)}
                  referrerPolicy="strict-origin-when-cross-origin"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  allowFullScreen
                />
              </div>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
